// CustomPrice.js
// Component for Custom Price Editing

// Imports
import React from 'react';
import { Checkbox, ControlGroup, InputGroup } from '@blueprintjs/core';
import PropTypes from 'prop-types';

// Component Class
// Shows Custom Price Field
class CustomPrice extends React.Component {
  // Constructor
  constructor(props) {
    super(props);

    this.state = {
      price: this.getDefaultPrice().toFixed(2),
      customPrice: this.hasCustomPrice(),
      validPrice: true,
      editing: false,
    };
  }

  // Checks if state must be updated
  componentDidUpdate(prevProps) {
    if (this.props.order !== prevProps.order) {
      this.setState({
        customPrice: this.hasCustomPrice(),
      });
    }
  }

  // Returns whether there is a custom price set
  hasCustomPrice = () => {
    var order = this.props.order;
    if (order == null) return false;
    var prodOrder = order[this.props.product.id];
    if (prodOrder == null) return false;
    return prodOrder.customPrice != null;
  }

  // Returns the default price
  getDefaultPrice = () => {
    return this.props.orderData.getProductTotal(this.props.product.id);
  }

  // Called when price field changes
  onPriceChange = (event) => {
    var value = Number.parseFloat(event.target.value);
    var valid = false;
    if (!Number.isNaN(value) && value > 0) {
      valid = true;
      this.props.setPrice(value);
    }
    this.setState({price: event.target.value, validPrice: valid, editing: true});
  }

  // Called when user finishes editing price field
  onPriceBlur = () => {    
    var value = Number.parseFloat(this.state.price);
    if (Number.isNaN(value) || value <= 0)
      value = this.getDefaultPrice();
    this.setState({price: value.toFixed(2), validPrice: true, editing: false});
  }

  // Called when the checkbox changes
  checkboxChanged = (event) => {
    var price = undefined;
    var defaultPrice = this.getDefaultPrice();
    if (event.target.checked)
      price = defaultPrice;
    
    this.props.setPrice(price);
    this.setState({customPrice: event.target.checked, price: defaultPrice.toFixed(2), validPrice: true});
  }

  // Returns the current order for the product, if any
  getOrder = () => {
    if (this.props.order) {
      var order = this.props.order[this.props.product.id];
      return order;
    }
    return null;
  }

  // Returns whether there is an associated product order
  hasOrder = () => {
    return this.getOrder() != null;
  }
  
  // Returns the current custom price
  getCustomPrice = () => {
    var order = this.getOrder();
    return order != null ? order.customPrice : undefined;
  }

  // Renders Component
  render() {
    var price = this.getDefaultPrice();
    var hasOrder = this.hasOrder();
    var customPrice = this.getCustomPrice();
    
    var priceField = price.toFixed(2);
    if (customPrice) {
      if (this.state.editing)
        priceField = this.state.price;
      else
        priceField = customPrice.toFixed(2);
    } 

    return (
      <ControlGroup fill vertical={false}>
        <Checkbox
          large
          disabled={!hasOrder}
          checked={this.state.customPrice}
          onChange={this.checkboxChanged}
        />
        <InputGroup
          intent={this.state.validPrice ? "":"danger"}
          disabled={!customPrice}
          fill
          placeholder="Total"
          value={priceField}
          leftIcon="dollar"
          onChange={this.onPriceChange}
          onBlur={this.onPriceBlur}
        />
      </ControlGroup>
    );
  }
}

// Required Properties
CustomPrice.propTypes = {
  order: PropTypes.object,
  product: PropTypes.object.isRequired,
  orderData: PropTypes.object.isRequired,
  setPrice: PropTypes.func.isRequired,
}

// Exports
export default CustomPrice;


// WEBPACK FOOTER //
// ./src/components/OrderView/CustomPrice.js